export default "__VITE_ASSET__BIv9UqAy__"